const KNOWLEDGE_BASE_ID_PARAM = 'knowledgeBaseId';

export function parseKnowledgeBaseIdFromSearchParams(
  searchParams: URLSearchParams,
): string | null {
  const value = searchParams.get(KNOWLEDGE_BASE_ID_PARAM)?.trim() ?? '';
  return value === '' ? null : value;
}

export function buildLacTenantStatsSearchParams(
  knowledgeBaseId: string | null,
): URLSearchParams {
  const params = new URLSearchParams();
  if (knowledgeBaseId != null && knowledgeBaseId.trim() !== '') {
    params.set(KNOWLEDGE_BASE_ID_PARAM, knowledgeBaseId.trim());
  }
  return params;
}
